import React from 'react';
import { FileQuestionIcon, SettingsIcon } from 'lucide-react';
interface UnavailableStateProps {
  variant: 'missing_pay_period' | 'unsupported_model';
  onClose: () => void;
}
const copy = {
  missing_pay_period: {
    icon: FileQuestionIcon,
    title: 'No pay period found',
    body: "This record isn't linked to an open Employee Pay Period, so a payment line item can't be created. Open the employee's current pay period and launch Add Payment from there.",
    action: 'Close'
  },
  unsupported_model: {
    icon: SettingsIcon,
    title: 'Commission model not supported',
    body: 'This pay period uses a commission model this form does not handle yet. Only Flat Fee and Standard models can be entered here — ask a payroll admin to correct the model on the employee record.',
    action: 'Close'
  }
};
export function UnavailableState({
  variant,
  onClose
}: UnavailableStateProps) {
  const {
    icon: Icon,
    title,
    body,
    action
  } = copy[variant];
  return <div className="px-6 py-12 text-center" data-id="element-228" data-mp="3iybc9887oy4c">
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-ink-100 text-ink-500" data-id="element-229" data-mp="3ix9xotrzlthv">
        <Icon className="h-7 w-7" aria-hidden="true" data-id="element-230" data-mp="3ew6kyg58kdkv" />
      </span>
      <h2 className="mt-5 text-lg font-semibold text-ink-900" data-id="element-231" data-mp="3swr5bgqsuhgh">{title}</h2>
      <p className="mx-auto mt-1 max-w-md text-sm leading-relaxed text-ink-500" data-id="element-232" data-mp="3nxegwrka52bs">{body}</p>
      <button type="button" onClick={onClose} className="mt-7 rounded-md border border-ink-200 bg-white px-5 py-2 text-sm font-semibold text-ink-700 transition hover:bg-ink-50 focus:outline-none focus:ring-4 focus:ring-ink-100" data-id="element-233" data-mp="3nvlclix52u6y">
        {action}
      </button>
    </div>;
}